<template>
	<b-card no-body>
		<!-- HEADER -->
		<b-card-header class="border-0">
			<b-row></b-row>
		</b-card-header>

		<!-- SEARCH INPUT -->
		<b-col cols="12">
			<b-row class="d-flex align-items-center justify-content-md-between">
				<b-col cols="12" md="6" class="d-md-flex">
					<base-input label="Search" v-model="searchQuery" prepend-icon="fas fa-search"
						placeholder="Search...">
					</base-input>
				</b-col>
			</b-row>
		</b-col>

		<!-- TABLE LIST -->
		<div class="table-listings">
			<el-table v-loading="isTableLoading" :data="queriedData" style="width: 100%;" >
				<!-- <el-table ref="multipleTable" v-loading="isTableLoading" :data="queriedData" style="width: 100%;" @selection-change="selectionChange" > -->
				<!-- <el-table-column type="selection" width="55" fixed="left" height="500"></el-table-column> -->

				<el-table-column prop="id" width="80" label="ID" sortable>
				</el-table-column>

				<el-table-column prop="name" label="Name" sortable>
					<template slot-scope="scope">
						<a href="javascript:void(0)" class="w-100 d-block" @click="editUser(scope.row)">{{ scope.row.name }}</a>
					</template>
				</el-table-column>

				<el-table-column prop="email" label="Email" min-width="120px" sortable>
					<template slot-scope="scope">
						<p>{{ scope.row.email }}</p>
					</template>
				</el-table-column>

				<el-table-column prop="roles" label="Roles" min-width="140px" sortable>
					<template slot-scope="scope">
						<p v-if="scope.row.current_user_application.role">{{ scope.row.current_user_application.role.role_name }}</p>
						<small class="badge badge-sm badge-info" v-if="_gHlp.getValue(scope.row.current_user_application,'setting_json.is_external_staff',false)">External Staff</small>

					</template>
				</el-table-column>

				<el-table-column prop="is_use_corp_subscription" label="Use Corporate Credit Balance" min-width="125px" sortable>
					<template slot-scope="scope">
						<span class="font-weight-bold"
							:class="(parseInt(scope.row.current_user_application.is_use_corp_subscription) > 0) ? 'text-success' : 'text-danger'">
							{{ (parseInt(scope.row.current_user_application.is_use_corp_subscription) > 0) ? "YES" : "NO" }}
						</span>
					</template>
				</el-table-column>

				<el-table-column prop="status_text" label="Status" sortable>
					<template slot-scope="scope">
						<span v-if="scope.row.status_text" class="font-weight-bold"
							:class="scope.row.status_text === 'ACTIVE' ? 'text-success' : 'text-danger'">{{ scope.row.status_text
							}}</span>
					</template>
				</el-table-column>

				<el-table-column prop="channel" label="Channel" sortable v-if="!app_code.includes('vps-v2')">
					<template slot-scope="scope">
						<div>
							<el-dropdown trigger="click" v-model="formParams.channel_id">
									<p class="el-dropdown-link top-line">
											<!-- <span :class="getRandomStatus().class">{{ getRandomStatus().value }}</span> -->
											<span v-if="scope.row.current_user_application.channel.name" v-b-tooltip.hover="scope.row.current_user_application.channel.name">{{ scope.row.current_user_application.channel.name | shortenText(16) }}</span>
											<span v-else>-</span>

											<i class="el-icon-caret-bottom el-icon--right"></i>
									</p>
									<el-dropdown-menu slot="dropdown" >
											<div style="max-height: 300px;overflow-y: auto;">
													<el-dropdown-item v-for="itemChannel in list_channels" :key="itemChannel.channel_id" @click.native="updateChanelPlatform(scope.row,itemChannel.channel_id,scope.row.current_user_application.platform.platform_id)">
															{{ itemChannel.name }}
													</el-dropdown-item>
											</div>
									</el-dropdown-menu>
							</el-dropdown>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="platform" label="Platform" sortable v-if="!app_code.includes('vps-v2')">
					<template slot-scope="scope">
						<div>
							<el-dropdown trigger="click" v-model="formParams.platform_id">
									<p class="el-dropdown-link top-line">
											<!-- <span :class="getRandomStatus().class">{{ getRandomStatus().value }}</span> -->
											<span v-if="scope.row.current_user_application.platform.name" v-b-tooltip.hover="scope.row.current_user_application.platform.name">{{ scope.row.current_user_application.platform.name | shortenText(16) }}</span>
											<span v-else>-</span>

											<i class="el-icon-caret-bottom el-icon--right"></i>
									</p>
									<el-dropdown-menu slot="dropdown" >
											<div style="max-height: 300px;overflow-y: auto;">
													<el-dropdown-item v-for="itemPlatform in list_platforms" :key="itemPlatform.platform_id" @click.native="updateChanelPlatform(scope.row,scope.row.current_user_application.platform.channel_id,itemPlatform.platform_id)">
															{{ itemPlatform.name }}
													</el-dropdown-item>
											</div>
									</el-dropdown-menu>
							</el-dropdown>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="hub" label="Hub" sortable>
					<template slot-scope="scope">
						<div v-if="scope.row.hub_type =='hub_manager'">
							{{ _gHlp.getValue(scope.row,'hub.group_name','-') }} /
							{{ _gHlp.getValue(scope.row,'hub.group_owner.name','-') }}
						</div>
						<div v-else-if="scope.row.hub_type =='team_manager' || scope.row.hub_type == 'member'">
							{{ _gHlp.getValue(scope.row,'hub.team_group.group_name','-') }} /
							{{ _gHlp.getValue(scope.row,'hub.team_group.group_owner.name','-') }}
						</div>
						<div v-else> - </div>
					</template>
				</el-table-column>

				<el-table-column prop="hub" label="Team" sortable>
					<template slot-scope="scope">
						<div v-if="scope.row.hub_type =='team_manager' || scope.row.hub_type == 'member'">
							{{ _gHlp.getValue(scope.row,'hub.team_group.group_owner.name','-') }} /
							{{ _gHlp.getValue(scope.row,'hub.team_owner.name','-') }}
						</div>
						<div v-else> - </div>
					</template>
				</el-table-column>

				<!-- <el-table-column label="#">
					<template slot-scope="scope">
							<el-popover placement="top-start" trigger="hover">
								<p>
										<strong class="mb-0 d-block">Created By : {{ scope.row.current_user_application.created_by ? scope.row.current_user_application.created_by.name : "-" }}</strong>
										<small class="mb-0 d-block">Created at : {{ scope.row.created_at | dateFormatString }}</small>
								</p>
								<i class='bx bxs-info-circle'>hloooo</i>
						</el-popover>
					</template>
				</el-table-column> -->

				<el-table-column
							width="130"
							class-name="text-center"
					>
							<template #header>
									<span class="text-center w-100">#</span>
							</template>
							<template slot-scope="scope">
								<el-popover
											placement="top-start"
											trigger="hover">
											<p>
													<strong class="mb-0 d-block">Created By : {{ scope.row.current_user_application.created_by ? scope.row.current_user_application.created_by.name : "-" }}</strong>
													<small class="mb-0 d-block">Created at : {{ scope.row.created_at | dateFormatString }}</small>
													<small class="mb-0 d-block">Last Login at : {{ scope.row.last_login_at | dateFormatString }}</small>
													<small class="mb-0 d-block">User Login Tracking : {{ (!_gHlp.isEmpty(scope.row.last_login_at) ? _gHlp.getDateDayDiff(scope.row.last_login_at) : '-') }}</small>
											</p>
											<b-avatar :style="{'background-color': 'black', 'color': 'white'}" size="32px" slot="reference"><b-icon icon="info" scale="2"></b-icon></b-avatar>
									</el-popover>
							</template>
					</el-table-column>

			</el-table>
		</div>

		<!-- FOOTER -->
		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap">
			<div class="d-flex align-items-center mb-3">
				<p class="card-category mb-0 text-secondary">
					Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>

				<span class="mb-0 ml-4">Rows:</span>

				<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" placeholder="Per page">
					<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
						:value="item">
					</el-option>
				</el-select>

			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="total" @change="paginationChanged($event)">
			</base-pagination>
		</div>

		<UpdateUserDrawer ref="update_user_drawer" :editData="editData" :listChanels="list_channels" :listPlatforms="list_platforms" @close="refreshData()" />
	</b-card>
</template>
<script>
import UpdateUserDrawer from '@/views/Configurations/UserManagement/Drawers/UpdateUserDrawer'
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem, Popover } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import mainEventBus from '@/assets/js/mainEventBus'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore';
import { useCommissionStore } from '@/stores/commissionStore'
import { useLookupStore } from '@/stores/lookupStore'

import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce,
	swal
} from '@/assets/js/httpImports.js'

export default {
	mixins: [helperFunctionMixin, notifyFunctionMixin, clientPaginationMixin],
	components: {
		BasePagination,
		UpdateUserDrawer,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
    [Popover.name]: Popover,
	},
	props: ['tableData'],
	data() {
		return {
			isTableLoading: true,
			propsToSearch: ['name','email','role_name'],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			TableColumn: [{
				type: 'selection'
			}],
			editData: {},
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			lookupTables: {},
			formParams:{
				channel_id:null,
				params_id:null,
			}
		}
	},
	async created() {
		// this.lookupTables = await this.getLookupTables(['platforms', 'channels'])
		this.getCommissionHubManagerUserList();
		this.getCommissionTeamManagerUserList();
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useConfigStore,['app_code']),
		...mapState(useLookupStore,['list_channels','list_platforms']),
		// listChanels(){
		// 		let dataList = this.lookupTables.channels;
		// 		let appCode = this.app_code;
		// 		return _.filter(dataList, function(o) { return (o.application_code == appCode) && (!o.deleted_at);; });
		// },
		// listPlatforms(){
		// 		let dataList = this.lookupTables.platforms;
		// 		let appCode = this.app_code;
		// 		return _.filter(dataList, function(o) { return (o.application_code == appCode) && (!o.deleted_at);; });
		// }
	},
	watch:{
			tableData(newVal){
				if(newVal.length > 0){
						this.isTableLoading = false
				}
			}
	},
	methods: {
		...mapActions(useCommissionStore,['getCommissionHubManagerUserList', 'getCommissionTeamManagerUserList']),
		refreshData(){
			this.$emit('refresh');
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
		},
		editUser(item) {
			const role_type = item.current_user_application.role.role_type ?? null;
			if(
					['corporate', 'manager'].includes(role_type) && 
					!_gHlp.checkRoleType(['corporate', 'admin']) &&
					this.auth_user.id !== item.id
			){
					this.errorFunction('You are not authorized to update this user.')
					return false;
			}
			
			this.editData = item;
			this.$refs.update_user_drawer.showDrawer();
		},
		updateChanelPlatform(item,chanel_id,platform_id){
			let data = {
				"name": item.name,
				"email": item.email,
				"contact_number": item.contact_number,
				"role_apps": [
					{
						"role_id": item.current_user_application.role.role_id,
						"corporate_id": item.current_user_application.corporate.id,
						"mlv_upl_id": item.current_user_application.mlv_upl_id,
						"mlv_pos_que": item.current_user_application.mlv_pos_que,
						"is_use_corp_subscription": item.current_user_application.is_use_corp_subscription,
						"channel_id": chanel_id,
						"platform_id": platform_id,
						"pull_report_limit_json": item.pull_report_limit_json,
					}
				],
				"status": item.status, // active
			}

			this.submitUpdate(item.id,data);
		},
		submitUpdate(id,params) {
			this.isTableLoading = true;
			axios.put(services.access_control + 'user/' + id, params, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>User:</b> - Successfully Updated.');
					this.refreshData();
					this.isTableLoading = false;
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
	}
}
</script>